import { ReactComponent as Icon } from "components/icons/left_arrow.svg";
import classes from "./AuthMoveBack.module.scss";

interface IProps {
  text: string;
  back?: () => void;
}

const AuthMoveBack = (props: IProps) => {
  const { text, back } = props;

  return (
    <div className={classes.Container}>
      { back && (
        <button type="button" className={classes.Button} onClick={back}>
          <Icon className={classes.Icon}/>
        </button>
      )}
      <p className={classes.Caption}>{text}</p>
    </div>
  );
};

export default AuthMoveBack;
